import React, { useEffect } from 'react';
import { i18n } from 'utils/i18n';
import FlyoutTabs from 'components/FlyoutTabs';
import { propTypes } from './LocationServicesPropTypes';

const LocationServices = ({ locationInfo, locationInfoById, id }) => {
  useEffect(() => {
    if (!locationInfo[id]) {
      locationInfoById(id);
    }
  }, []);

  const createLocationServicesItems = () => {
    const locationInfoHashTable = locationInfo[id]?.location?.service_indicators;
    if (!locationInfoHashTable) {
      return false;
    }

    // Location has both: Title = After-hours Services
    // Location has AH pickup but not AH return: Title = After-hours Pickup
    // Location has AH return but not AH pickup: Title = After-hours Return
    // Location has neither: Title = After-hours Services
    const i18nKeyForAfterHoursTitle =
      (locationInfoHashTable.afterHoursPickup &&
        locationInfoHashTable.offersAfterHoursDropoff &&
        'location_service_after_hours_services') ||
      (locationInfoHashTable.afterHoursPickup && 'location_service_after_hours_pickup') ||
      (locationInfoHashTable.offersAfterHoursDropoff && 'location_service_after_hours_dropoff') ||
      'location_service_after_hours_services';

    const serviceItems = [
      {
        //  Self Service Kosk
        name: i18n('location_service_kiosk'),
        disabled: !locationInfoHashTable.kiosk,
        icon: 'kiosk',
        content: `<p>${i18n('location_service_service_kiosk_paragraph')}</p>`,
      },
      {
        //  Skip counter
        name: i18n('location_service_skip_counter'),
        disabled: !locationInfoHashTable.skipTheCounter,
        icon: 'counter',
        content: `<p>${i18n('location_service_skip_the_counter_paragraph')}</p> <p>${i18n(
          'location_service_skip_the_counter_paragraph_2'
        )}</p>`,
      },
      {
        //  Online Check in
        name: i18n('location_service_online_checkin'),
        disabled: !locationInfoHashTable.onlineCheckIn,
        icon: 'check-in',
        content: `<p>${i18n('location_service_online_check_in_paragraph')}</p>`,
      },
      {
        //  After-Hours Services
        name: i18n(i18nKeyForAfterHoursTitle),
        disabled: !(locationInfoHashTable.afterHoursPickup || locationInfoHashTable.offersAfterHoursDropoff),
        icon: 'after-hours',
        content: `<h3>${i18n('location_service_after_hours_services_header')}</h3>
        <p>${i18n('location_service_after_hours_services_paragraph')}</p>
        <h3>${i18n('location_service_after_hours_services_header_2')}</h3>
        <p>${i18n('location_service_after_hours_services_paragraph_2')}</p>`,
      },
    ];

    return serviceItems.sort((a) => (a.disabled ? 1 : -1)); // put the disabled ones last
  };

  const locationServicesItems = createLocationServicesItems();

  return locationServicesItems && <FlyoutTabs items={locationServicesItems} />;
};

LocationServices.propTypes = propTypes;

export default LocationServices;
